export const enum EStatusDemanda {
    AguardandoPreenchimentoDemandante = 1,
    AguardandoAnalisePreSuprimentos = 2,
    AguardandoRCDemandante = 3,
    AguardandoGeracaoOCnoTotvs = 4,
    AguardandoAnaliseSuprimentos = 5,
    OnHoldDemandante = 6,
    Cancelada = 7,
    Concluido = 8,
    AguardandoAnaliseControleFinanceiro = 9,
    AguardandoGeracaoOCePreSuprimentosDDI = 10,

    AguardandoQuestionarioMinuta = 11,
    AguardandoConfirmacaoQuestionarioMinuta = 12,
    AguardandoGeracaoMinuta = 13,
    AguardandoGestorTecnico = 14,
    AguardandoAnaliseControladoria = 15,
    AguardandoRCDemandanteModificacao = 16,
    AguardandoAnaliseControleFinanceiroModificacao = 17,
    AguardandoAnaliseControladoriaModificacao = 18,
    AguardandoGeracaoOCnoTotvsModificacao = 19,
    AguardandoRCReabertura = 20,
    AguardandoContratacaoSuprimentosReavaliacao = 21,
    AguardandoAnaliseControleFinanceiroReavaliacao = 22,
    AguardandoAnaliseControladoriaReavaliacao = 23,
    AguardandoRCDemandanteReavaliacao = 24,
    AguardandoGeracaoOCnoTotvsReavaliacao = 25,
    AguardandoGerenteDepartamento = 26,
    AguardandoGerenteGeral = 27,
}